// extracted by mini-css-extract-plugin
export default {"root":"Textarea_root__p3rBW"};